import { computed, onBeforeMount } from 'vue'

import { useHomepageStore } from '@/stores/homepageComponents'

export const fetchHeroStore = () => {
  const homepageStore = useHomepageStore()

  onBeforeMount(async () => {
    await homepageStore.fetchAllHomepageComponents()
  })
}

export const useHeroTitle = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.herosection?.title)
}

export const useHeroOpenAccountButton = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.herosection?.buttonsrepeater[0])
}

export const useHeroDemoButton = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.herosection?.buttonsrepeater[1])
}

export const useHeroImageDesktop = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore?.getHomepageData?.herosection?.herodesktopimage)
}

export const useHeroImageMobile = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.herosection?.heromobileimage1)
}

export const useHeroAwardsItems = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.herosection?.awardsrepeater)
}

export const useHeroAdvantagesItems = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.herosection?.advantagesrepeater)
}

export const useSponsorLogo = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.herosection?.sponsor_logo)
}

export const useSponsorTitle = () => {
  const homepageStore = useHomepageStore()
  return computed(() => homepageStore.getHomepageData?.herosection?.sponsor_title)
}
